let language = {
    REGIST_PARTNER_VERIFY_TIP_TITLE_TEXT: "Verify Your Email",
    REGIST_PARTNER_VERIFY_TIP_HINTONE_TEXT: "You’re almost there ! We sent an email to",
    REGIST_PARTNER_VERIFY_TIP_HINTTWO_TEXT: ". Just click on the link in that email to complete your sign up. If you don’t see it, you may need to check your spam folder ",
    
    REGIST_PARTNER_VERIFY_TIP_RESEND_MAIL_TEXT: "Resend Verification Mail",
    REGIST_PARTNER_VERIFY_TIP_OK_TEXT: "OK",

};

export { language }